module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/heavyTank-prem.07e9422b.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/heavyTank-prem.png
// module id = 2718
// module chunks = 11